// src/lib/supabaseClient.js
// Client-side Supabase client - ALWAYS uses anon key for browser safety
/* global globalThis */

const { createClient } = require('@supabase/supabase-js');
const cookieStorage = require('./cookieStorage');

// Determine the appropriate global scope depending on the environment
const globalScope =
  typeof globalThis !== 'undefined'
    ? globalThis
    : typeof window !== 'undefined'
    ? window
    : global;

const isBrowser = typeof window !== 'undefined';

// ✅ ALWAYS use anon key for client-side - NEVER use service role key here
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Fail fast if env vars are missing
if (!supabaseUrl) throw new Error('supabaseUrl is required.');
if (!supabaseKey) throw new Error('supabaseKey is required.');

// Singleton pattern to ensure only one instance
if (!globalScope._supabaseClient) {
  console.log('✨ Creating new Supabase client instance (anon key, cookie storage)');

  globalScope._supabaseClient = createClient(supabaseUrl, supabaseKey, {
    auth: {
      persistSession: isBrowser,
      storageKey: 'supabase.auth.token',
      storage: isBrowser ? window.localStorage : undefined,
      detectSessionInUrl: isBrowser,
      autoRefreshToken: true,
      flowType: 'implicit'
    },
    realtime: {
      disabled: false
    }
  });
} else {
  console.log('♻️  Reusing existing Supabase client instance');
}

module.exports = globalScope._supabaseClient;